var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgOpenIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1473_37955)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M38 0H10C4.47715 0 0 4.47715 0 10V38C0 43.5228 4.47715 48 10 48H38C43.5228 48 48 43.5228 48 38V10C48 4.47715 43.5228 0 38 0Z",
    fill: "#F1EFE8"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 11,
    y: 12,
    width: 26,
    height: 8,
    rx: 4,
    fill: "#5F5E5A"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 11,
    y: 22,
    width: 20,
    height: 6,
    rx: 3,
    fill: "#B1AFAA"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 11,
    y: 30,
    width: 20,
    height: 6,
    rx: 3,
    fill: "#B1AFAA"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1473_37955"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOpenIcon);
export default __webpack_public_path__ + "static/media/OpenIcon.3b16b2519a3cfbcf7f755bafbf242b41.svg";
export { ForwardRef as ReactComponent };